

















































































































import { Vue, Component } from "vue-property-decorator";
import { get, post } from "@/util/request";
import UpdateDictionaryForm from "../list/components/UpdateDictionaryForm.vue";
import  UpdateDictionaryType  from "../list/components/UpdateDictionaryType.vue";
@Component({
  components: {
    UpdateDictionaryForm,
    UpdateDictionaryType
  }
})
export default class dictionaryManage extends Vue {
  //接口数据
  private dictionaryData: any[] = [];
  private visibleCreateModal: boolean = false;
  private visibleCreateTableModal:boolean=false;
  private updateDictionaryFormVisible: boolean = false;
  private updateDictionaryTypeVisible:boolean=false;
  private updateRecord: any = {};
  private updateTypeRecord:any={}
  private dictData:any={}

  private form:any={}
  private tableForm:any={}

  private columns: any[] = [
    {
      title: "key",
      dataIndex: "key"
    },
    {
      title: "value",
      dataIndex: "value"
    },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

 //新建表格 ,点击弹窗
  private handleTableCreate(item: any){
   this.dictData=item
   this.visibleCreateTableModal=true;
  }

  private handleCreateTableModalCancel(){
    this.visibleCreateTableModal=false;
  }

  //table 新建保存
   private handleCreateTableModalOk(){
     this.tableForm.validateFields((err: any,values: any)=>{
      if(err){
        return;
      }
        post('dict/data/insert',{
       typeId:this.dictData.id,
       key:values.key,
       value:values.value
       }).then(res=>{
         if(res.data.code!=0){
           this.$message.error(res.data.message)
         }else{
            this.loadData();
            this.$message.success(res.data.message)
            this.visibleCreateTableModal=false;
         }
       }).catch(err=>{
         console.log(err)
       })
     })


  }

//折叠面板删除
private popCollapseConfirm(record:any){
      post("dict/type/delete",{
           id:record.id
       }).then(res=>{
         if(res.data.code!=0){
           this.$message.error(res.data.message)
         }else{
           this.$message.success(res.data.message)
           this.loadData()
         }
       }).catch(err=>{
         console.log(err)
       })
}

  //重置
  private handleFormReset() {}

  private handleSearch() {}
  //编辑按钮点击调用显示弹窗
  private handleUpdateModalVisible(visible: boolean, record: any): void {
    this.updateDictionaryFormVisible = true;
    this.updateRecord = record;
  }

  // 新建，插入数据库，默认都是可修改，system=0
  private handleCreateModalOk(){
    this.form.validateFields((err: any,values: any)=>{
      if(err){
        return;
      }
       post('dict/type/insert',{
        name:values.name,
        desc:values.desc
     }).then(res=>{
       //判断信息，是否保存成功，回调查询接口,隐藏界面
       if(res.data.code!=0){
         this.$message.error(res.data.message)
       }else{
         this.loadData()
         this.$message.success(res.data.message)
         this.visibleCreateModal=false;
       }
     }).catch(err=>{
       console.log(err)
     })
    })
  }


  private handleCreateModalCancel(){

    this.visibleCreateModal=false;
  }

  //折叠面板类型编辑方法，修改描述
  private handleEdit(visible:boolean,record:any) {
    this.updateDictionaryTypeVisible=visible
    this.updateTypeRecord=record
  }

  //删除折叠面板
  private handleDelete() {

  }
  //新建，建一个折叠面板，
  private handleCreate() {
  // this.form=this.$form.createForm(this,{name:'coor'})  //声明变量的时候不能写，必须这样写
    this.visibleCreateModal=true;
  }

  //删除table，网络请求
  private popconfirm(record: any) {
    post("dict/data/delete", {
          id: record.id
        }).then(res => {
        if(res.data.code!=0){
          this.$message.error(res.data.message)
        }else{
        //删除刷新数据
          this.$message.success(res.data.message)
          this.loadData();
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  private created() {
     this.form=this.$form.createForm(this,{name:'form'})
      this.tableForm=this.$form.createForm(this,{name:'tableForm'})
    this.loadData();
  }

   private sortbykey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    }

  //网络请求，初始加载数据
  private loadData() {
    get("dict/type/query", {})
      .then(res => {
        this.dictionaryData = res.data.data.sysDictTypes;
        //对table的key进行排序
        for(let i=0;i<this.dictionaryData.length;i++){
          this.dictionaryData[i].dataVOs=this.sortbykey(this.dictionaryData[i].dataVOs,"key")
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
}
